import { render } from "./familydata.vue?vue&type=template&id=5ecf1e3d&scoped=true"
import script from "./familydata.vue?vue&type=script&lang=js"
export * from "./familydata.vue?vue&type=script&lang=js"

import "./familydata.vue?vue&type=style&index=0&id=5ecf1e3d&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\GCTUSMS\\codev1\\apply_online\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecf1e3d"]])

export default __exports__